var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.5214,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3170_2877",
    transform: "matrix(0.0219948 0 0 0.0208333 -0.0278754 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3170_2877",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACUklEQVR4nO3YS4jNUQDH8fGI8gjRIFlIHguFoimvUh4b1oqVxGaashFSFlgoKYqS1xYLK0rJwmNjgSR5TGpYMowwo/EYH50c9e/WHfd//////Zf+37p1unXO+f7uedxzTltbRUVFRUVFi8AGnMdL9MdPKJ/D+mHqjcAmHG6Va63AfNz1b+5gXqLeFOzEE/xAR5pO92JmDvJr0Kdx+nAINzGY+H532o5D6keYnEF+QUr5ehxppvNPsfJDTGsyQCPTZjjCCHRhIfahs9GOR+FXoqEXoZGU8utl5x0+x/I9jEkT4GdNY2FEtqUIEHaWvHiA9jQ/YBB4WqexG2FuN1A/jFoeXMP4VPJRYP8wjQ7hMlaGPbpO/S85yH8PsyG1fBSYiJ4GOnmD09iOJZiFcfJhqCn5RIil+KA8BjMFSIToLSnA+yziGxPl6bhUQoAnWQK8wv34t96Jo3jd4gBXswQ4oXwOZAkwGx9LDrCq6QAxxGZ8K0m+F6MzBUhcQt6WEOBMZvlEiHacqjmfF82SvORHJspT444UdqciuZmLfJS+FbfPcJy9jWfxelcUQ1iWZ4COeKhqFRdyk0+E2NqiED2YlHuAGGJ5vCMXxSBWFCJf8z6zDmfjhedrTvK/wigXKl8nzC4M5CDf1Wr5tXFHysoAthQlOTa+jM3BoriQj8X3ojzoxuIixMMcf6w4wm52EhNyl695VtmR48vCX/GLmFuYeJ2FGub7lQyLNYzmnnDZbysTf9bEahyMb0PdiXfP/nhifY7rOB7XzIxSpSsqKioq/nt+A1rS7nj9iHZTAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0ee605e92530c59077042aa97a3a032b.svg";
export { ForwardRef as ReactComponent };